import { Alert, Box, Grid, Typography } from "@mui/material";
import React, { useState } from "react";

import { ReactComponent as HomeIcon } from "../../static/svg/home.svg";
import { ReactComponent as ClockIcon } from "../../static/svg/clock.svg";
import { ReactComponent as PhoneIcon } from "../../static/svg/phone.svg";
import { ReactComponent as MailIcon } from "../../static/svg/mail.svg";
import { ReactComponent as WhatsappIcon } from "../../static/svg/socials/whatsapp.svg";

import CustomButton from "../Form/CustomButton";
import { CustomInput, CustomTextArea } from "../Form/CustomInputField";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { createDocument } from "../../firebase/firebaseCrud";

export const ContactBody = () => {
  const [formData, setFormData] = useState({
    userName: "",
    message: "",
  });

  const CHARACTER_LIMIT = 100;

  const { userName, message } = formData;

  const [errMsg, setErrMsg] = useState("");

  let navigate = useNavigate();

  const handleSubmit = async (e) => {
    // prevent the form from refreshing the whole page
    e.preventDefault();

    setErrMsg("");

    if ((formData.userName = "")) {
      setErrMsg("Please input mobile number");
    } else if (formData.message < CHARACTER_LIMIT) {
      setErrMsg("Please input your message");
    } else {
      try {
        // Regex expression to remove all characters which are NOT alphanumeric
        // let number = mobileNumber.replace(/[^\w\s]/gi, "").replace(/ /g, "");
        let userNumber = 447936794742;

        // Appending the phone number to the URL
        let url = `https://web.whatsapp.com/send?phone=${userNumber}`;
        let newUrl = `https://wa.me/${userNumber}?text=Hello%20*StrandzByDee*%0AMy%20name%20is%20*${userName}*%0AMSG:%20${message}`;

        // Appending the message to the URL by encoding it
        url += `&text=${encodeURI(message)}&app_absent=0`;

        // Open our newly created URL in a new tab to send the message
        window.open(newUrl);

        setFormData([""]);
        toast(
          `Thank you for contacting us, we will revert back at you shortly`,
          {
            type: "success",
          },
        );
        window.location.reload();
      } catch (error) {
        setErrMsg("Error sending message");

        console.error("Error sending message:", error);
      }
    }
  };

  return (
    <React.Fragment>
      <Grid container spacing={0} className="pt-16 lg:px-20 ">
        <Grid
          item
          xs={12}
          sm={6}
          md={7}
          className=" relative order-2 md:order-1"
        >
          <Box className=" my-8 p-1 md:p-4 space-y-6 place-content-center justify-center w-2/3 mx-auto">
            <Box className=" flex items-start gap-4">
              <HomeIcon className=" text-[#C3073F] h-12 w-12" />
              <Box className=" w-full lg:w-[50%]">
                <Typography
                  variant="h3"
                  // fontWeight={800}
                  fontSize={{ xs: "14px", sm: "15px", md: "16px" }}
                  lineHeight={{ xs: "103%", sm: "105.5%" }}
                  letterSpacing={"-0.05em"}
                  color="primary"
                  className=" pb-1"
                >
                  Business address
                </Typography>
                <Typography
                  variant="subtitle"
                  fontSize={{ xs: "12px", sm: "12px", md: "12px" }}
                  lineHeight={{ xs: "100%", sm: "160%" }}
                  letterSpacing={"-0.02em"}
                  color={"primary"}
                  className=" opacity-50"
                >
                  193b London Road CR0 2RJ
                </Typography>
              </Box>
            </Box>
            <Box className=" flex items-start gap-4">
              <ClockIcon className=" text-[#C3073F] h-12 w-12" />
              <Box className=" w-full lg:w-[50%]">
                <Typography
                  variant="h3"
                  // fontWeight={800}
                  fontSize={{ xs: "14px", sm: "15px", md: "16px" }}
                  lineHeight={{ xs: "103%", sm: "105.5%" }}
                  letterSpacing={"-0.05em"}
                  color="primary"
                  className=" pb-1"
                >
                  Opening hours
                </Typography>
                <Typography
                  variant="subtitle"
                  fontSize={{ xs: "12px", sm: "12px", md: "12px" }}
                  lineHeight={{ xs: "100%", sm: "160%" }}
                  letterSpacing={"-0.02em"}
                  color={"primary"}
                  className=" opacity-50"
                >
                  10AM - 5 PM, Sunday closed
                </Typography>
              </Box>
            </Box>
            <Box className=" flex items-start gap-4">
              <PhoneIcon className=" text-[#C3073F] h-12 w-12" />
              <Box className=" w-full lg:w-[50%]">
                <Typography
                  variant="h3"
                  // fontWeight={800}
                  fontSize={{ xs: "14px", sm: "15px", md: "16px" }}
                  lineHeight={{ xs: "103%", sm: "105.5%" }}
                  letterSpacing={"-0.05em"}
                  color="primary"
                  className=" pb-1"
                >
                  Office contact
                </Typography>
                <Typography
                  variant="subtitle"
                  fontSize={{ xs: "12px", sm: "12px", md: "12px" }}
                  lineHeight={{ xs: "100%", sm: "160%" }}
                  letterSpacing={"-0.02em"}
                  color={"primary"}
                  className=" opacity-50"
                >
                  +447 936 794742 (Whatsapp | SMS)
                </Typography>
              </Box>
            </Box>
            <Box className=" flex items-start gap-4">
              <MailIcon className=" text-[#C3073F] h-12 w-12" />
              <Box className=" w-full lg:w-[50%]">
                <Typography
                  variant="h3"
                  // fontWeight={800}
                  fontSize={{ xs: "14px", sm: "15px", md: "16px" }}
                  lineHeight={{ xs: "103%", sm: "105.5%" }}
                  letterSpacing={"-0.05em"}
                  color="primary"
                  className=" pb-1"
                >
                  Email us
                </Typography>
                <Typography
                  variant="subtitle"
                  fontSize={{ xs: "12px", sm: "12px", md: "12px" }}
                  lineHeight={{ xs: "100%", sm: "160%" }}
                  letterSpacing={"-0.02em"}
                  color={"primary"}
                  className=" opacity-50"
                >
                  hello@strandzbydee.com
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={5}
          className=" relative order-1 md:order-2"
        >
          {errMsg !== "" ? (
            <Box className="px-3 md:px-12">
              <Alert
                severity="error"
                onClose={() => {
                  setErrMsg("");
                }}
              >
                {errMsg}
              </Alert>
            </Box>
          ) : null}
          <Box as="div" className="w-3/4 mx-auto my-8 p-1 md:p-0">
            <ToastContainer />

            <Box className=" flex items-center mb-2">
              <WhatsappIcon className=" h-6 w-6" />
              <Typography
                variant="h3"
                // fontWeight={800}
                fontSize={{ xs: "14px", sm: "15px", md: "16px" }}
                lineHeight={{ xs: "103%", sm: "105.5%" }}
                letterSpacing={"-0.05em"}
                color="primary"
                className=" pb-1"
              >
                Let's connect on Whatsapp
              </Typography>
            </Box>

            <Grid container spacing={2} item={true} className="">
              <Grid xs={12} sm={12} md={12} item={true}>
                <div className=" text-center">
                  <CustomInput
                    label="Name"
                    type="name"
                    className="w-full"
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        userName: e.target.value,
                      });
                      setErrMsg("");
                    }}
                    value={formData.userName}
                    required
                  />
                </div>
              </Grid>
            </Grid>

            <Grid xs={12} sm={12} md={12} item={true}>
              <div className=" text-center my-4">
                <CustomTextArea
                  label="Message"
                  type="text"
                  className="w-full"
                  multiline
                  rowNo={4}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      message: e.target.value,
                    });
                    setErrMsg("");
                  }}
                  value={formData.message}
                  required
                />
              </div>
            </Grid>

            <div className="text-center mx-auto">
              <CustomButton
                type="submit"
                // form="add-member-form"
                //   loading={true}
                sx={{ width: "150px", height: "55px" }}
                color="secondary"
                className="text-sm !uppercase"
                // onClick={() => {
                //   console.log("Form", formData);
                // }}
                onClick={handleSubmit}
                // to={"/checkout"}
                // fullWidth
              >
                Submit
              </CustomButton>
            </div>
          </Box>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};
